$(function() {

  var currentStore = $('#plus-cd_current').data('country-preference');
  var currentURL = location.host;
  

  var queryString = window.location.search.substr(1);
  var queryString = queryString.replace("p=redirect", "");

  if(queryString.indexOf("&rfsn") > -1) {
    var redirectQ = '?p=redirect';
  } else if(queryString.indexOf("rfsn") > -1){
    var redirectQ = '?p=redirect&';
  } else {
    var redirectQ = '?p=redirect';
  }


  function checkURL(countryPreference, currentURL) {
    if (countryPreference.slice(8) !== currentURL ) {
      location.replace(countryPreference + redirectQ + queryString);
    } 
  }
  
  function setStorage(countryPreference) {
    window.localStorage.setItem('dryrobeStorePreference', countryPreference);
  }
 
  

  
    // open dropdown on hover
    $('.plus-cd-header_current').hover(function() {
        $('.plus-cd-header_options-wrapper').addClass('plus-dropdown-visible');
      }, function() {
        setTimeout(function() {
          $('.plus-cd-header_options-wrapper').removeClass('plus-dropdown-visible')
        }, 1000);
    });

    // change localStorage with dropdown
    $('.plus-cd-header_options li').on('click', function() {
      var countryPreference = $(this).data('country-preference');
      setStorage(countryPreference);
      checkURL(countryPreference, currentURL);
    });
  

  // check if this was a redirect from another country's store
  // open popup if not, otherwise set the localStorage to this store
  if (location.href.indexOf(redirectQ) > -1) {
    setStorage(document.location.origin);
  } 
});
